import React, { useRef, useState } from "react";
import Heading from "../../../components/common/user-profile/heading";
import { ADMIN_EDIT_ICON, UPLOAD_IMAGE_DUMMY } from "../../../utils/app-image-contant";
import Input from "../../../components/common/input";
import { useSelector } from "react-redux";
import { UserProfileChange, uploadMultipartFile } from "../../../hooks/services/api-services";
import { toastEmitter } from "../../../utils/utilities";
import { API_RESPONSE } from "../../../utils/app-constants";
import { setLoggedUserReducer } from "../../../hooks/redux/slice/logged-user";
import { useDispatch } from "react-redux";

const UserProfile = ({ closeRef }) => {
  const imgRef = useRef();
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state?.loggedUser);
  const [userProfile, setUserProfile] = useState(value?.profileImage)
  const [buttonStatus, setButtonStatus] = useState(false)
  const [profilePayload, setProfilePayload] = useState({
    userId: value?.userId,
    profileImage: userProfile,
  });

  const handleImgClick = (e) => {
    imgRef.current.click();
  };

  const OnFileUpload = (e) => {
    let file = e?.target?.files?.[0];
    let fileName = e.target.files[0].name;
    setUserProfile(URL?.createObjectURL(file));
    if (file?.size > 5242880) {
      toastEmitter(
        "error",
        "Failed to upload an image. The image maximum size is 5MB."
      );
      return false;
    }
    if (
      file?.type === "image/png" ||
      file?.type === "image/jpeg" ||
      file?.type === "image/jpg"
    ) {
      uploadProfile(file, fileName)
    } else {
      return toastEmitter(
        "error",
        "The type of the uploaded image should be in png, jpeg, jpg format."
      );
    }
  };

  const handleChangeProfile = async (body) => {
    setButtonStatus(true)
    try {
      const response = await UserProfileChange(body);
      if (response?.data?.responseCode == 200) {
        setButtonStatus(false)
        toastEmitter("success", response?.data?.message);
        closeRef.current.click();
        dispatch(setLoggedUserReducer(response?.data?.responseBody));
      }else{
        toastEmitter("error", "Please try again");
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  }

  const uploadProfile = async (file, fileName) => {
    const formdata = new FormData();
    formdata.append("docfile", file, fileName);
    formdata.append("folderName","UserDoc" );
    setButtonStatus(true)
    try {
      const response = await uploadMultipartFile(formdata);
      if (response?.data?.responseCode == 200) {
        setButtonStatus(false)
        profilePayload.profileImage = response?.data?.data
        setUserProfile(response?.data?.data)
        handleChangeProfile(profilePayload)
      } else {
        setButtonStatus(false)
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }

  }


  return (
    <>
      <div className="white_card card_height_100 mb_30 user_crm_wrapper">
        <div className="row">
          <div className="col-lg-12 ">
            <div className="crm_body">
              <Heading title="USER PROFILE / उपयोगकर्ता प्रोफ़ाइल" />
              <div className="d-flex justify-content-center mb-3 ">
                <div className="text-center position-relative">
                  <img
                    src={userProfile !== null || userProfile !== "" || userProfile !== undefined ? userProfile : UPLOAD_IMAGE_DUMMY}
                    alt="User-profile"
                    className="user-web-prfile-img"
                  />
                  <div className="text-center mb-40 user-profile-edit-icon">
                    <img
                      src={ADMIN_EDIT_ICON}
                      alt=""
                      onClick={handleImgClick}
                      className="top-edit-user-icon cursorPointer"
                    />
                    <input
                      className="form-control"
                      type="file"
                      hidden
                      ref={imgRef}
                      id="imgFileUpload"
                      accept="image/*"
                      onChange={OnFileUpload}
                    />
                  </div>

                </div>


              </div>
              <div className="row mb-3">
                <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                  <Input
                    lableName="User Name / उपयोगकर्ता नाम"
                    pdf_Icon={false}
                    value={value?.name}
                    info_Icon={false}
                    disabled={true}
                    mandatory={false}
                  />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                  <Input
                    lableName="UserId / उपयोगकर्ता आई डी"
                    pdf_Icon={false}
                    value={value?.userId}
                    info_Icon={false}
                    disabled={true}
                    mandatory={false}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                  <Input
                    lableName="User Mobile No. / उपयोगकर्ता मोबाइल नं."
                    pdf_Icon={false}
                    value={value?.mobileNumber}
                    info_Icon={false}
                    disabled={true}
                    mandatory={false}
                  />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                  <Input
                    lableName="User Email / उपयोगकर्ता ईमेल"
                    pdf_Icon={false}
                    value={value?.email}
                    info_Icon={false}
                    disabled={true}
                    mandatory={false}
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
